import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Paginator } from "primereact/paginator";
import { Tooltip } from "primereact/tooltip";

const List = ({
  columns,
  data,
  loading = false,
  onSelectionChange,
  selectedRecords,
  handlePageChange,
  handleOnSortChange,
  handleRowClick,
  selectionMode = "checkbox",
  pageQuery = {},
  pagination = true,
  dataKey = "id",
  totalRecords = 0,
  scrollHeight = "calc(100vh - 64px - 20px - 42px - 250px)",
}) => {
  const intl = useIntl();
  return (
    <div className="edexlms-list">
      <DataTable
        value={data}
        tableStyle={{ minWidth: "50rem" }}
        stripedRows
        paginator={false}
        rows={pageQuery.pageSize || 50}
        rowHover
        dataKey={dataKey}
        scrollHeight={scrollHeight}
        selection={selectedRecords}
        onSelectionChange={onSelectionChange}
        selectionMode={selectionMode}
        rowsPerPageOptions={[10, 20, 50, 100]}
        sortField={pageQuery.sortColumn || "name"}
        sortOrder={pageQuery.sortBy === "asc" ? 1 : -1}
        loading={loading}
        size="normal"
        rowClassName={() =>
          `edexlms-list-row ${handleRowClick ? "cursor-pointer" : ""}`
        }
        onAllRowsSelect={(e) => onSelectionChange(e.data)}
        onAllRowsUnselect={(e) => onSelectionChange([])}
        onRowClick={handleRowClick}
        onSort={handleOnSortChange}
        scrollable
        emptyMessage={intl.formatMessage({ id: "no_records_found" })}
      >
        {(selectionMode === "checkbox" && (
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "3rem" }}
          ></Column>
        )) ||
          null}
        {columns.map((column, index) => {
          const messages =
            (column.infoMessage &&
              (Array.isArray(column.infoMessage)
                ? column.infoMessage
                    .map((message) => intl.formatMessage({ id: message }))
                    .join(", ")
                : intl.formatMessage({ id: column.infoMessage }))) ||
            "";
          return (
            <Column
              key={index}
              {...column}
              alignHeader={column.headerIcon ? "center" : "left"}
              header={
                <>
                  <Tooltip target={`#${column.header}`} />
                  {column.headerIcon ? (
                    <span className={`pi ${column.headerIcon}`}></span>
                  ) : column.i18n === false ? (
                    <span>{column.header}</span>
                  ) : (
                    <span>{intl.formatMessage({ id: column.header })}</span>
                  )}
                  {(column.infoMessage && (
                    <span
                      data-pr-position="bottom"
                      style={{ marginLeft: "3px", cursor: "pointer" }}
                      id={column.header}
                      data-pr-tooltip={messages}
                      className="pi pi-fw pi-info-circle"
                    ></span>
                  )) ||
                    null}
                </>
              }
            />
          );
        })}
      </DataTable>
      {(pagination && (
        <Paginator
          template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
          rowsPerPageOptions={[10, 20, 50, 100]}
          rows={pageQuery.pageSize || 50}
          totalRecords={totalRecords || data.length}
          onPageChange={handlePageChange}
          first={(pageQuery.pageNo - 1) * pageQuery.pageSize}
        />
      )) ||
        null}
    </div>
  );
};

List.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  selectedRecords: PropTypes.array,
  onSelectionChange: PropTypes.func,
  selectionMode: PropTypes.string,
  loading: PropTypes.bool,
  handleRowClick: PropTypes.func,
  handlePageChange: PropTypes.func,
  totalRecords: PropTypes.number,
  scrollHeight: PropTypes.string,
};

export default List;
